import React from 'react';
import { Link } from 'react-router-dom';
import { cx, focusRing } from '../ds/classes';

/**
 * The Producer's Friend mark: a coral half-sun rising over five amber meter bars, the same geometry
 * as the design system's logo-mark.svg. The sun is always coral and the bars always amber; only for
 * dark grounds (base, chrome, surface), at 32px and up. The only motion it ever has is `rise`: its
 * bars rise once, left to right, on the studio loading screen (and not at all under reduced motion).
 */
const BARS = [
  { x: 9, y: 50, height: 8 },
  { x: 19, y: 44, height: 14 },
  { x: 29, y: 40, height: 18 },
  { x: 39, y: 44, height: 14 },
  { x: 49, y: 50, height: 8 },
];
const RISE_DELAYS = ['', '[animation-delay:80ms]', '[animation-delay:160ms]', '[animation-delay:240ms]', '[animation-delay:320ms]'];

export const LogoMark = ({ className = 'w-9 h-9', rise = false }) => (
  <svg viewBox="0 0 64 64" aria-hidden="true" className={cx('flex-none', className)}>
    <path d="M14 36 A18 18 0 0 1 50 36 Z" className="fill-coral" />
    {BARS.map((bar, i) => (
      <rect
        key={bar.x}
        x={bar.x}
        y={bar.y}
        width="6"
        height={bar.height}
        rx="3"
        className={cx('fill-amber', rise && 'animate-bar-rise motion-reduce:animate-none origin-bottom [transform-box:fill-box]', rise && RISE_DELAYS[i])}
      />
    ))}
  </svg>
);

/** The mark and the name, linking home (nav and footer) */
export const Brand = () => (
  <Link to="/" className={cx('inline-flex items-center gap-space-3 min-h-target-min rounded-radius-md text-ink no-underline', focusRing)}>
    <LogoMark />
    <span className="font-display text-project text-ink whitespace-nowrap">The Producer's Friend</span>
  </Link>
);
